module.exports = __webpack_public_path__ + "static/img/ultrasound.473d9739.png";